import { ToastProvider } from '@/context/Toast';
import { HrFont } from '@components/styles/hr-styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { I18nextProvider } from 'react-i18next';
import { createGlobalStyle } from 'styled-components';
import i18n from '../i18n';
import DisplaySettingsProvider from './store/display-settings';
import ContextStoreProvider from './store/store-provider';
import { PostulantFormRoutes } from './views';

const GlobalStyle = createGlobalStyle`
  p {
    font-family: ${HrFont};
  }
`;

const queryClient = new QueryClient();

function PostulationForm({ reCaptcha, cloudflareRecaptcha, drive, clientAppDrive }) {
  ReactDOM.render(
    <StrictMode>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <I18nextProvider i18n={i18n} key='translate'>
            <ContextStoreProvider key='recaptcha' data={{ drive, clientAppDrive }}>
              {cloudflareRecaptcha ? (
                // Si existe cloudflareRecaptcha, no renderizamos GoogleReCaptchaProvider
                <>
                  <GlobalStyle />
                  <DisplaySettingsProvider>
                    <PostulantFormRoutes key='crud-postulant' cloudflareRecaptcha={cloudflareRecaptcha} />
                  </DisplaySettingsProvider>
                </>
              ) : (
                // Si no existe cloudflareRecaptcha, renderizamos GoogleReCaptchaProvider
                <GoogleReCaptchaProvider
                  useRecaptchaNet
                  useEnterprise='true'
                  reCaptchaKey={reCaptcha}
                  scriptProps={{ async: true, defer: true, appendTo: 'body' }}
                >
                  <GlobalStyle />
                  <DisplaySettingsProvider>
                    <PostulantFormRoutes key='crud-postulant' />
                  </DisplaySettingsProvider>
                </GoogleReCaptchaProvider>
              )}
            </ContextStoreProvider>
          </I18nextProvider>
        </QueryClientProvider>
      </ToastProvider>
    </StrictMode>,
    document.getElementById('app')
  );
}

export default PostulationForm;
